import { trigger, state, style, transition, animate } from '@angular/animations';
import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { DataService } from 'src/app/service/data.service';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from "@angular/router";
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { FormsModule } from '@angular/forms';

import { SearchedProductService } from 'src/app/service/SearchedProductService';
import { SearchRequest } from 'src/app/shared/models/searchRequest'; 


@Component({
  selector: 'app-navbars',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    FormsModule
  ],
  templateUrl: './navbars.component.html',
  styleUrls: ['./navbars.component.scss'],
  animations: [
    trigger('fade',
      [
        state('void', style({ opacity: 0 })),
        transition(':enter', [animate(300)]),
        transition(':leave', [animate(500)]),
      ]
    )]
})
export class NavbarsComponent implements OnInit {

  // Variables Añadidas / Existentes
  isMenuOpen = false; // Controla el menú de hamburguesa móvil (collapse)
  isHomeMenuOpen = false; // 👈 NUEVA VARIABLE: Controla el menú desplegable "Home"
  public cartProductCount: number = 0;
  public searchTerm!: string;

  constructor(
    private data: DataService,
    @Inject(DOCUMENT) public document: Document,
    private router: Router,
    private searchedProductService: SearchedProductService 
  ) { }

  ngOnInit(): void {
    this.data.getProductsCount().subscribe(res => {
      this.cartProductCount = res.length;
    });

    this.data.search.subscribe((val: any) => {
      this.searchTerm = val;
    });
  }

  // Funciones Añadidas / Existentes
  
  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }
  
  // 👈 NUEVA FUNCIÓN: Alterna el estado del menú desplegable "Home"
  toggleHomeMenu(): void {
    this.isHomeMenuOpen = !this.isHomeMenuOpen;
    
    // Opcional: Si quieres cerrar el menú móvil si se abre el dropdown (aunque es raro en navbars)
    // if (this.isHomeMenuOpen) {
    //   this.isMenuOpen = false;
    // }
  }


  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e: Event) {
    if (window.pageYOffset > 400) {
      this.document.getElementById('navbar')?.classList.add('sticky');
    } else {
      this.document.getElementById('navbar')?.classList.remove('sticky');
    }
  }

  /**
   * Lógica de búsqueda mejorada para enviar el término al servicio antes de navegar.
   * Obtiene el userId de sessionStorage si está disponible.
   */
  search(): void {
    if (!this.searchTerm) {
      return; 
    }

    const clienteData = localStorage.getItem('cliente');
    let userId = 'mock-user-id';

    if (clienteData) {
      try {
        const cliente = JSON.parse(clienteData);
        if (cliente && cliente.uid) {
          userId = cliente.uid;
        }
      } catch (e) {
        console.error('Error al parsear los datos del cliente de sessionStorage', e);
      }
    }

    const searchRequest: SearchRequest = {
      searchTerm: this.searchTerm,
      userId: userId
    };

    this.searchedProductService.handleProductSearch(searchRequest).subscribe({
      next: (response) => {
        console.log('Búsqueda registrada con éxito:', response.message);
      },
      error: (err) => {
        console.error('Error al registrar la búsqueda:', err.message);
      }
    });

    this.data.search.next(this.searchTerm);

    if (this.router.url !== '/product') {
      this.router.navigate(['/product']);
    }
  }
}